import { Rate, Tooltip } from "antd"
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { ExpandableText } from "../../../atoms/ExpandableText";
import "../../../../Styles/ReviewsAndFaQ.css"
import { LeftCircleFilled, LeftCircleTwoTone, LeftOutlined, RightCircleFilled, RightCircleTwoTone, RightOutlined, ShopOutlined } from "@ant-design/icons";
import googleLogo from "../../../../assets/logo_google.png"
import { calculateDays } from "../../../../common/utils/caculateDays";

export const MaxcolchonWidgetsReviews = ({ id: webConfigId }) => {

    let { id: widgetId } = useParams();
    const key = webConfigId || widgetId;
    const location = useLocation();
    const storeCode = new URLSearchParams(location.search).get('storeCode');
    const locality = new URLSearchParams(location.search).get('locality');
    
    let extraQueryParams = storeCode ? '&storeCode=' + storeCode : '';    

    const { data: reviews, isLoading: reviewsLoading } = useFetch(
        //`${process.env.REACT_APP_API}/web/reviews?key=${key}&widget=${!webConfigId}${extraQueryParams}` ,
        `${process.env.REACT_APP_API}/widgets/last-reviews?key=${key}${extraQueryParams}` ,
        {},
        [],
    );

    const [itemsPerPage, setItemsPerPage] = useState(3);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            let newItemsPerPage = 4;

            if (window.innerWidth < 700) {
                newItemsPerPage = 1;
            } else if (window.innerWidth < 900) {
                newItemsPerPage = 2;
            } else if (window.innerWidth < 1024) {
                newItemsPerPage = 3;
            }

            if (newItemsPerPage !== itemsPerPage) {
                setItemsPerPage(newItemsPerPage);
                setCurrentPage(1);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [itemsPerPage]);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, reviews.length);
    const currentReviews = reviews.slice(startIndex, endIndex);

    const handleNextPage = () => {
        setCurrentPage(Math.min(currentPage + 1, Math.ceil(reviews.length / itemsPerPage)));
    };

    const handlePrevPage = () => {
        setCurrentPage(Math.max(currentPage - 1, 1));
    };

    return (
        <div>           
            <div style={{display:'flex', justifyContent:'center', alignItems: 'center', flexDirection: 'column', fontSize: '28px', fontFamily:'Montserrat', fontWeight:400, height: '84px'}}>
                <div>Opiniones de clientes de la tienda</div>
                <b>{locality}</b>
            </div>
            <div style={{height:'372px', background:'#f6f6f6', fontFamily:'Montserrat'}}>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', height:'310px' }}>
                    {currentReviews.map((review, index) => {
                        return <div key={index} style={{ width: '300px', marginTop: '35px' }}>
                            <div className='comment-review' style={{ height: '182px', overflow: 'auto', borderRadius:'5px 5px 5px 0px', border:'solid 1px #E0E0E0', padding:'20px', color:'black' }}>
                                <div style={{ display: 'flex', flexDirection:'column', gap:'5px' }}>
                                    <b><small style={{ color: 'black' }}>{calculateDays(review?.createdTime)}</small></b>                                
                                </div>
                                <ExpandableText
                                    comment={review?.comment}
                                    length={200} />
                            </div>
                            <div className="web-content-reviews-profile" style={{ position: 'relative' }}>
                                <div style={{ borderRadius: '50%', overflow: 'hidden', width: 50, height: 50, display: 'flex', justifyContent: 'center' }}>
                                    <img src={review?.reviewerProfilePhotoUrl} style={{ height: '100%', width: 'auto' }} />
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                    <p style={{ fontSize: '14px', margin: 0, fontWeight: 500, width: '175px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{review?.reviewerDisplayName}</p>
                                    <Rate style={{ fontSize: '13px', color: '#fcbc0b' }} disabled defaultValue={review?.starRating} />
                                </div>

                                <div style={{ background: 'white', padding: 5, position: 'absolute', width: 30, height: 30, borderRadius: '50%', top: '50%', left: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={googleLogo} style={{ height: '100%', width: 'auto' }} />
                                </div>

                            </div>

                        </div>
                    })}
                </div>
                <div style={{display:'flex', justifyContent: 'center', alignItems:'center', gap:'25px', background:'transparent'}}>
                    <button 
                        class='button-pagination'
                        onClick={handlePrevPage} disabled={currentPage === 1}>
                        <LeftOutlined
                            style={{borderRadius:'50%', fontSize: '11px', padding:'10px', background: currentPage === 1 ? "#e4e4e4" : "#757575", color: 'white'}}
                        />
                    </button>
                    <button
                    class='button-pagination'
                        onClick={handleNextPage} disabled={endIndex >= reviews.length}>
                        <RightOutlined
                            style={{borderRadius:'50%', fontSize: '11px', padding:'10px', background: endIndex >= reviews.length ? "#e4e4e4" : "#757575", color: 'white'}}
                        />
                    </button>
                </div>
            </div>
        </div>
    )
}